import { render, staticRenderFns } from "./ErtesitesListaItem.vue?vue&type=template&id=4b8d87c3&"
import script from "./ErtesitesListaItem.vue?vue&type=script&lang=js&"
export * from "./ErtesitesListaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports